<template>
  <div class="textatea__wrp">
    <textarea
      @blur="$emit('blur')"
      class="bim-textarea"
      :class="{ error__form: observableError }"
      :placeholder="placeholder"
      :name="name"
      :id="id"
      @input="$emit('input', $event.target.value)"
      :value="observableValue"
      :disabled="disabled"
      :style="`
        background: ${background};
        width: ${computedWidth};
        height: ${computedHeight};
       `"
    >
    </textarea>

    <bimErrorField :error="observableError" />
  </div>
</template>

<script>
import ValidationFormMixin from '@/utils/validate2/validation-form-mixin'
import bimErrorField from '@/components/form/bimErrorField/bimErrorField'

export default {
  name: 'bimTextarea',
  mixins: [ValidationFormMixin],
  components: {
    bimErrorField
  },
  props: {
    /**
     * Значение текстового поля
     * @model
     */
    value: {
      type: [String, Number]
    },
    /**
     * Имя текстового поля
     */
    name: {
      type: String
    },
    /**
     * ID текстового поля
     */
    id: {
      type: String,
      default: function () { return 'radio-id-' + this._uid }
    },
    /**
     * Значение placeholder
     */
    placeholder: {
      type: String,
      default: 'Введите текст'
    },
    /**
     * Отключает текстовое поле
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Заменяет фон инпута (transparent не прадлагать)
     */
    background: {
      type: String,
      default: '#ffffff'
    },
    /**
     * Ширина
     */
    width: {
      type: [String, Number],
      default: '300'
    },
    /**
     * Высота
     */
    height: {
      type: [String, Number],
      default: '136'
    },
  },
  data () {
    return {
      observableValue: this.value,
      // rows: null
    }
  },
  watch: {
    value (value) {
      this.observableValue = value
    }
  },
  // mounted () {
  //   if (this.autofocus) this.onAutofocus()
  // },
  computed: {
    // uniqRef () {
    //   return 'input' + this._uid
    // },
    computedHeight () {
      if (+this.height) {
        return this.height + 'px'
      } else {
        return this.height
      }
    },
    computedWidth () {
      if (+this.width) {
        return this.width + 'px'
      } else {
        return this.width
      }
    },
  },
  // methods: {
  // onAutofocus () {
  //   this.$refs[this.uniqRef].$el.focus()
  // },
  // getRows (value) {
  //   this.$emit('input', this.value)
  //   this.rows = document.getElementById(this.id).value.split(/\r|\r\n|\n/).length
  // }
  // },
}
</script>

<style lang="scss" scoped>
.bim-textarea {
  box-sizing: border-box;
  width : 100%;
  padding: 14px;
  display: block;

  font-family: inherit;

  border: solid 1px rgba($black-color, .25);
  border-radius: 5px;
  outline: none;
  transition: all .15s;

  resize: none;
  @include text-style (14px, normal, 1.43, .2px);

  &:hover, &:focus {
    border-color: rgba($black-color, .5);
  }

  &::placeholder {
    color: rgba($black-color, .4);
  }

  &:disabled {
    border-color: rgba($black-color, .1);
    color: rgba($black-color, .6);
    background-color: $white-color;
  }

  &.error__form {
    border-color: $red-color-400;
  }

  &.error__form::placeholder {
    color: $red-color-400;
    opacity: 1;
  }
}
</style>
